import React, { useEffect } from "react";
import {Button, Form, InputNumber, Switch} from "antd";
import { SettingInterface } from "src/store/community/settingsSlice";
import { PoweroffOutlined, CloseCircleOutlined } from '@ant-design/icons';

import '../Settings.scss';
import { DollarOutlined } from "@ant-design/icons";

interface propsInterface {
  onFinish: Function;
  params?: SettingInterface['data'] | undefined;
}

const _RemoveAds = ({ onFinish, params }: propsInterface) => {
  const [form] = Form.useForm();
  const allowNative = Form.useWatch(['allow_remove_ads', 'native'], form);
  const allowBanner = Form.useWatch(['allow_remove_ads', 'banner'], form);
  const allowAppOpen = Form.useWatch(['allow_remove_ads', 'app_open'], form);
  const allowInterstitial = Form.useWatch(['allow_remove_ads', 'interstitial'], form);
  const allowInterstitialLong = Form.useWatch(['allow_remove_ads', 'interstitial_long'], form);

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      className='v-form v-settings-form'
      layout="vertical"
      autoComplete="off"
      initialValues={params}
    >
      <Form.Item className='v-mb-0'>
        <Form.Item
          name={['remove_ads', 'native']}
          rules={[{ required: true, message: 'Missing value' }]}
          style={{ display: 'inline-block' }}
        >
          <InputNumber
            addonBefore='native'
            min={0}
            step={5}
            placeholder='0'
            prefix={<DollarOutlined />}
            disabled={!allowNative}
          />
        </Form.Item>

        <Form.Item
          name={['allow_remove_ads', 'native']}
          valuePropName='checked'
          style={{ display: 'inline-block', width: '44px', margin: '6px 0 0 8px' }}
        >
          <Switch
            checkedChildren={<PoweroffOutlined />}
            unCheckedChildren={<CloseCircleOutlined />}
          />
        </Form.Item>
      </Form.Item>

      <Form.Item className='v-mb-0'>
        <Form.Item
          name={['remove_ads', 'banner']}
          rules={[{ required: true, message: 'Missing value' }]}
          style={{ display: 'inline-block' }}
        >
          <InputNumber
            addonBefore='banner'
            min={0}
            step={5}
            placeholder='60'
            prefix={<DollarOutlined />}
            disabled={!allowBanner}
          />
        </Form.Item>

        <Form.Item
          name={['allow_remove_ads', 'banner']}
          valuePropName='checked'
          style={{ display: 'inline-block', width: '44px', margin: '6px 0 0 8px' }}
        >
          <Switch
            checkedChildren={<PoweroffOutlined />}
            unCheckedChildren={<CloseCircleOutlined />}
          />
        </Form.Item>
      </Form.Item>

      <Form.Item className='v-mb-0'>
        <Form.Item
          name={['remove_ads', 'app_open']}
          rules={[{ required: true, message: 'Missing value' }]}
          style={{ display: 'inline-block' }}
        >
          <InputNumber
            addonBefore='app open'
            min={0}
            step={5}
            placeholder='75'
            prefix={<DollarOutlined />}
            disabled={!allowAppOpen}
          />
        </Form.Item>

        <Form.Item
          name={['allow_remove_ads', 'app_open']}
          valuePropName='checked'
          style={{ display: 'inline-block', width: '44px', margin: '6px 0 0 8px' }}
        >
          <Switch
            checkedChildren={<PoweroffOutlined />}
            unCheckedChildren={<CloseCircleOutlined />}
          />
        </Form.Item>
      </Form.Item>

      <Form.Item className='v-mb-0'>
        <Form.Item
          name={['remove_ads', 'interstitial']}
          rules={[{ required: true, message: 'Missing value' }]}
          style={{ display: 'inline-block' }}
        >
          <InputNumber
            addonBefore='interstitial'
            min={0}
            step={5}
            placeholder='120'
            prefix={<DollarOutlined />}
            disabled={!allowInterstitial}
          />
        </Form.Item>

        <Form.Item
          name={['allow_remove_ads', 'interstitial']}
          valuePropName='checked'
          style={{ display: 'inline-block', width: '44px', margin: '6px 0 0 8px' }}
        >
          <Switch
            checkedChildren={<PoweroffOutlined />}
            unCheckedChildren={<CloseCircleOutlined />}
          />
        </Form.Item>
      </Form.Item>

      <Form.Item className='v-mb-0'>
        <Form.Item
          name={['remove_ads', 'interstitial_long']}
          rules={[{ required: true, message: 'Missing value' }]}
          style={{ display: 'inline-block' }}
        >
          <InputNumber
            addonBefore='interstitial long'
            min={0}
            step={5}
            placeholder='100'
            prefix={<DollarOutlined />}
            disabled={!allowInterstitialLong}
          />
        </Form.Item>

        <Form.Item
          name={['allow_remove_ads', 'interstitial_long']}
          valuePropName='checked'
          style={{ display: 'inline-block', width: '44px', margin: '6px 0 0 8px' }}
        >
          <Switch
            checkedChildren={<PoweroffOutlined />}
            unCheckedChildren={<CloseCircleOutlined />}
          />
        </Form.Item>
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Apply
        </Button>
      </Form.Item>
    </Form>
  );
}

export default _RemoveAds;
